import baseApplicationItem from './baseApplicationItem'
import { merge } from 'lodash'

const module = {
  endpoint: 'admin/catalog/product/technicaldetail',
  getNew: {
    id: null,
    label: null,
    type: 1
  }
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/technicalDetails.js